import { render, staticRenderFns } from "./SocialMediaButtons.vue?vue&type=template&id=0887f0ae&scoped=true&"
import script from "./SocialMediaButtons.vue?vue&type=script&lang=js&"
export * from "./SocialMediaButtons.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaButtons.vue?vue&type=style&index=0&id=0887f0ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0887f0ae",
  null
  
)

export default component.exports